// import { infoFetchGetTituloI, makeTitulo } from "dtos/titulo"
import {
  FetchCallbackI,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { ENDPOINTS } from "./endpoints";
import { servicesUtils } from "./utils/services.utils";
import { infoFetchOrganismoI, makeOrganismo, Organismo } from "dtos/organismo";
import { OutPaginationDto } from "dtos/OutPaginationDto";
import { OrganismoI } from "interfaces/Organismo";
import { EntityID } from "api/types/EntityID";

export class FindOrganismosFiltersDto
{
  page!: number;
  limit!: number;
  nombre!: string;
}

export const findOrganismos = async (params: FindOrganismosFiltersDto) : Promise<OutPaginationDto<Organismo>> => {
  const response = await sendRequest<OutPaginationDto<OrganismoI>>({
    method: "GET",
    uri: ENDPOINTS.ORGANISMO,
    params: servicesUtils.removeNullParamsInFilters(params as Record<string, any>),
  });

  return {
    page: response.page,
    cantidad: response.cantidad,
    elementos: response.elementos.map((ct) => makeOrganismo(ct)),
  }
};

export const getAllOrganismos = async () => {
  const elementos = await sendRequest<infoFetchOrganismoI[]>({
    method: "GET",
    uri: ENDPOINTS.ORGANISMO_ALL,
  });

  return elementos.map((ct) => makeOrganismo(ct));
};

export const postOrganismo = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchOrganismoI>({
    method: "POST",
    uri: ENDPOINTS.ORGANISMO,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeOrganismo(response);
};

export const putOrganismo = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchOrganismoI>({
    method: "PUT",
    uri: ENDPOINTS.ORGANISMO,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeOrganismo(response);
};

export const deleteOrganismo = async (organismoId: EntityID) => {
  const response = await sendRequest({
    method: "DELETE",
    uri: `${ENDPOINTS.ORGANISMO}/${organismoId}`,
  });
  return response;
};
